import { Main } from './components/containers/Main';

const ProductCategories = () => <Main />;

export default ProductCategories;
